export const SEND_EMAIL_DEBOUNCE_MS = 2000;
export const REDIRECT_DELAY_MS = 1000;

export const INVALID_EMAIL_ERROR = 'Invalid email address';
export const DUPLICATE_EMAIL_ERROR = 'This email is already added';

export const EMAIL_BODY_ARIA_LABEL = 'Email body';
// The 10rem the CKEditor body kept as its minimum height.
export const LOAN_EMAIL_BODY_MIN_HEIGHT_PX = 160;
